import { FC, useEffect, useRef, useState } from "react";
import SimpleDataTable from "../common/simple-data-table";
import { FEATURES_COLUMNS } from "lib/constants/table-columns";
import { Button, Form } from "react-bootstrap";
import { PiPlusBold } from "react-icons/pi";
import SimpleModal from "../common/simple-modal";
import { Formik, FormikProps } from "formik";
import FlexBox from "../common/flex-box";
import SimpleTextbox from "../common/simple-textbox";
import SimpleSwitch from "../common/simple-switch";
import { DEFAULT_FEATURE_VALUES } from "lib/constants/default-values";
import ArrayService from "lib/services/array-service";

interface FeaturesDataTableProps {
  data: FeatureDetails[];
  isEditable?: boolean;
  label?: string;
  onChange?: (value: FeatureDetails[]) => void;
}

const FeaturesDataTable: FC<FeaturesDataTableProps> = ({
  data,
  isEditable = true,
  label = "Features",
  onChange,
}) => {
  const [showModal, setShowModal] = useState(false);
  const formikRef = useRef<FormikProps<any>>(null);
  const [features, setFeatures] = useState<FeatureDetails[]>(data);
  const [selectedFeature, setSelectedFeature] = useState<FeatureDetails>(
    DEFAULT_FEATURE_VALUES
  );
  const featuresService = new ArrayService<FeatureDetails>("id");

  useEffect(() => {
    setFeatures(data ?? []);
    setSelectedFeature(DEFAULT_FEATURE_VALUES);
  }, [data]);

  const closeModal = () => setShowModal(false);

  const handleFeatureSelection = (feature: FeatureDetails) => {
    const selectedFeatureIndex = features.findIndex(
      (item) => item.id === feature.id
    );
    if (selectedFeatureIndex !== -1) {
      setSelectedFeature(features[selectedFeatureIndex]);
      setShowModal(true);
    }
  };

  const handleAddFeature = (values: FeatureDetails) => {
    onChange?.(featuresService.addItem(features, values));

    setSelectedFeature(DEFAULT_FEATURE_VALUES);
    closeModal();
  };
  const handleUpdateFeature = (values: FeatureDetails) => {
    onChange?.(featuresService.updateItem(features, values.id, values));

    setSelectedFeature(DEFAULT_FEATURE_VALUES);
    closeModal();
  };
  const handleDeleteFeature = (values: FeatureDetails) => {
    onChange?.(featuresService.removeItem(features, values));
    setSelectedFeature(DEFAULT_FEATURE_VALUES);
    closeModal();
  };

  return (
    <>
      <FlexBox>
        <legend>{label}</legend>
        <>
          {isEditable && (
            <Button size="sm" onClick={() => setShowModal(true)}>
              <PiPlusBold />
            </Button>
          )}
        </>
      </FlexBox>
      <SimpleDataTable
        columns={FEATURES_COLUMNS}
        data={features}
        isShowPagination={false}
        onRowClick={(row) => {
          handleFeatureSelection(row as FeatureDetails);
        }}
      />
      <SimpleModal
        open={showModal && isEditable}
        close={closeModal}
        size="sm"
        title={selectedFeature.id ? "Edit Feature" : "Add Feature"}
        footer={
          <FlexBox
            className="w-100"
            justifyContent="between"
            alignItems="center"
          >
            <Button
              type="button"
              variant="outline-danger"
              className="w-auto"
              onClick={() => handleDeleteFeature(selectedFeature)}
            >
              delete
            </Button>
            <Button
              type="button"
              className="w-auto"
              onClick={() => formikRef.current?.handleSubmit()}
            >
              Save
            </Button>
          </FlexBox>
        }
      >
        <Formik
          innerRef={formikRef}
          initialValues={selectedFeature}
          onSubmit={(values: FeatureDetails) => {
            console.log("values", values);
            if (selectedFeature.id) handleUpdateFeature(values);
            else handleAddFeature(values);
            //onClose(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              <SimpleTextbox
                label="Feature Name"
                name="label"
                value={values.label}
                onChange={handleChange}
              />
              {/* <Form.Group className="form-group">
                <Form.Label>
                  Label&nbsp;<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${
                    touched.label && errors.label ? "is-invalid" : ""
                  }`}
                  onBlur={handleBlur}
                  type="text"
                  name="label"
                  value={values.label}
                  onChange={handleChange}
                />
                {touched.label && errors.label && (
                  <div className="invalid-feedback">
                    {errors.label as string}
                  </div>
                )}
              </Form.Group> */}
              <SimpleSwitch
                onChange={handleChange}
                value={values.isAvailable}
                name="isAvailable"
                label="Feature Available"
              />
              {/* <Form.Group className="form-group">
                <div className="d-flex align-items-center gap-2">
                  <MdCancel
                    className="text-danger flex-shrink-0 me-2"
                    size={20}
                  />
                  <Form.Check
                    type="switch"
                    name="isAvailable"
                    checked={selectedFeature.isAvailable}
                    onChange={(e) => {
                      console.log("e", e.target.checked);
                      setSelectedFeature({
                        ...selectedFeature,
                        isAvailable: e.target.checked,
                      });
                      handleChange(e);
                    }}
                  />
                  <div>
                    <FaCheckCircle className="text-success flex-shrink-0 me-2" />
                    (Available)
                  </div>
                </div>

                <Form.Label></Form.Label>
              </Form.Group> */}
            </Form>
          )}
        </Formik>
      </SimpleModal>
    </>
  );
};

export default FeaturesDataTable;
